export default (params) => {
  const { fieldData, fieldType } = params;

  const {
    document: { nodes: documentNodes },
  } = fieldData;

  let updatedOrgs = [...documentNodes];
  documentNodes.forEach((organization, orgInd) => {
    if (orgInd % 2 !== 0) return;

    const { nodes: orgNodes } = organization;
    let updatedOrg = { ...organization };

    orgNodes.forEach((orgNode, orgNodeInd) => {
      if (orgNodeInd % 2 === 0) return;

      let updatedRole = { ...orgNode };
      const { nodes: roleNodes } = orgNode;
      roleNodes.forEach((roleNode, roleNodeInd) => {
        const { type } = roleNode;
        let updatedRoleNode = { ...roleNode };
        if (type.includes('_description') || type.includes('_achievements')) {
          const { nodes: roleNodeChildren } = roleNode;
          const roleNodeChildrenLength = roleNodeChildren.length;
          if (roleNodeChildrenLength === 1) {
            const [roleNodeChild] = roleNodeChildren;
            const { type: roleNodeType, text } = roleNodeChild;
            if (roleNodeType === 'paragraph' && !text) {
              updatedRoleNode = {
                ...updatedRoleNode,
                nodes: [
                  {
                    object: 'block',
                    type: 'unordered_list',
                    nodes: [
                      {
                        object: 'block',
                        type: 'list_item',
                        nodes: [
                          {
                            object: 'block',
                            type: 'paragraph',
                            nodes: [
                              {
                                object: 'text',
                                leaves: [
                                  {
                                    text: '',
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              };
              updatedRole = {
                ...updatedRole,
                nodes: [
                  ...updatedRole.nodes.slice(0, roleNodeInd),
                  updatedRoleNode,
                  ...updatedRole.nodes.slice(roleNodeInd + 1),
                ],
              };
            }
          }
        }
      });
      updatedOrg = {
        ...updatedOrg,
        nodes: [
          ...updatedOrg.nodes.slice(0, orgNodeInd),
          updatedRole,
          ...updatedOrg.nodes.slice(orgNodeInd + 1),
        ],
      };
    });

    updatedOrgs = [
      ...updatedOrgs.slice(0, orgInd),
      updatedOrg,
      ...updatedOrgs.slice(orgInd + 1),
    ];
  });

  const updatedOrganizations = {
    ...fieldData,
    document: {
      ...fieldData.document,
      data: {
        ...fieldData.document.data,
        version: {
          number: 5,
          updated: true,
        },
      },
      nodes: updatedOrgs,
    },
  };
  return { [fieldType]: updatedOrganizations };
};
